import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import HtmlParser from 'react-html-parser';

import {
    responseGet, globalSettings, separatorsNumbersSet, styles, validateDecimals, numberSet, buttonProcessGet, languageObjGet, isUndNullEmp, sendMessageCloseCurrentWindowAsync,
    awaitDelay
} from '../../helpers/settings';
import { purchaseDetailsCalculate } from '../../controllers/expenses/purchases';
import { purchaseDetailModelGet, purchaseModelGet } from '../../models/expenses/purchase';
import { taxModelGet } from '../../models/taxes/tax';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'PurchaseConceptEdit';

export default function PurchaseConceptEdit({
    $ = {},
    auth = {},
    neutralValue = 0.00,
    purchase = purchaseModelGet({}),
    setPurchase = () => { },
    purchaseDetail = purchaseDetailModelGet({}),
    setPurchaseDetail = () => { },
    purchaseDetails = [purchaseDetailModelGet({})],
    setPurchaseDetails = () => { },
    dtId = '',
    rowIndex = 0,
    taxes = [taxModelGet({})],
    showModal = false,
    setShowModal = () => { },
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region others
    const taxesId = 'taxes';
    const taxEmptyId = '';
    const [quantityError, setQuantityError] = useState(neutralValue);
    const [priceError, setPriceError] = useState(neutralValue);
    const [percentageError, setPercentageError] = useState('');
    const [remarkError, setRemarkError] = useState('');
    const controls = {
        buttons: {
            save: {
                id: 'btnModalPurchaseConceptEditSave',
                className: 'btn btn-outline-warning mx-1',
            },
            back: {
                id: 'btnModalPurchaseConceptEditBack',
                className: 'btn btn-outline-success',
            },
            close: {
                id: 'btnModalPurchaseConceptEditClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        inputs: {
            quantity: {
                id: 'inputModalPurchaseConceptEditQuantity',
                className: 'form-control text-right',
            },
            price: {
                id: 'inputModalPurchaseConceptEditPrice',
                className: 'form-control text-right',
            },
        },
        dataTables: {
            conceptsFind: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm',
                    //     id: 'btnDtExpenseConceptsCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtExpenseConceptsCreate',
                    //     className: globalSettings?.icons?.plusCircle,
                    // },
                },
                inputs: {
                    // search: {
                    //     id: `${dtConceptsFindId}_filter input`,
                    //     className: '',
                    // },
                },
                selects: {
                    // entries: {
                    //     id: `${dtConceptsFindId}_length select`,
                    //     className: '',
                    // },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtExpenseConceptsCreate',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            save: {
                id: 'icoModalPurchaseConceptEditSave',
                className: globalSettings?.icons?.save,
            },
            back: {
                id: 'icoModalPurchaseConceptEditBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
        },
        spinners: {
            save: {
                id: 'spModalPurchaseConceptEditSave',
                className: '',
            },
            back: {
                id: 'spModalPurchaseConceptEditBack',
                className: '',
            },
        },
    };
    //#endregion others

    //#region purchase details (methods)
    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            const neutralValueStr = separatorsNumbersSet({
                number: neutralValue,
                withDecimals: true,
                consoleLogErrorShow: true,
                subMethod: currentMethod,
            })?.result;
            //#endregion variables

            //#region methods
            purchaseDetail.quantity = numberSet({
                number: purchaseDetail?.quantity,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            purchaseDetail.price = numberSet({
                number: purchaseDetail?.price,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;

            if (purchaseDetail?.quantity <= neutralValue) {
                setQuantityError(`${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }

            if (purchaseDetail?.price <= neutralValue) {
                setPriceError(`${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: purchaseDetail?.taxId, subMethod: currentMethod, })?.result) {
                setPercentageError(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            //#endregion variables
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptsEditAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptsEditAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            const taxObj = {
                id: $(`#${taxesId}`)?.val(),
                percentage: 0.00,
            };
            let purchaseDetailsBefore = Object?.assign({}, purchaseDetails);
            //#endregion variables

            //#region error default set
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion error default set

            //#region form data validate
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion form data validate

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region update purchase detail
            //#region set tax data to purchaseDetail
            taxObj.percentage = purchaseDetail?.taxId !== taxEmptyId ?
                taxes?.find(({ id }) => id === purchaseDetail?.taxId)?.percentage :
                neutralValue;
            purchaseDetail.taxId = taxObj?.id;
            purchaseDetail.taxPercentage = !isUndNullEmp({ data: taxObj?.percentage, subMethod: currentMethod, })?.result ? taxObj?.percentage : neutralValue;
            //#endregion set tax data to purchaseDetail

            //#region order by concepts
            purchaseDetailsBefore = purchaseDetails?.filter(({ expenseConceptId }) => expenseConceptId !== purchaseDetail?.expenseConceptId);
            purchaseDetailsBefore = [...purchaseDetailsBefore, purchaseDetail,];
            const key = globalSettings?.collections?.properties?.description;
            //purchaseDetailsBefore?.sort((a, b) => a?.[key]?.toLowerCase()?.localeCompare(b?.[key]?.toLowerCase()));
            purchaseDetailsBefore?.sort((a, b) => a?.[key]?.toLowerCase() > b?.[key]?.toLowerCase() ? 1 : -1);
            //#endregion order by concepts

            //#region set subTotal, tax, taxAmount, total, exemptAmount, taxBase
            response = purchaseDetailsCalculate({
                neutralValue: neutralValue,
                purchaseDetails: purchaseDetailsBefore,
                purchase: purchase,
                setPurchase: setPurchase,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setPurchaseDetails(purchaseDetailsBefore);
            //#endregion set subTotal, tax, taxAmount, total, exemptAmount, taxBase

            //#region purchase add details (datatable)
            //#region variables
            const amountsStr = {
                quantity: separatorsNumbersSet({
                    number: purchaseDetail?.quantity,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                price: separatorsNumbersSet({
                    number: purchaseDetail?.price,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                taxPercentage: separatorsNumbersSet({
                    number: taxObj?.percentage,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                subTotal: separatorsNumbersSet({
                    number: numberSet({
                        number: purchaseDetail?.quantity * purchaseDetail?.price,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
            };
            //#endregion variables

            $(`#${dtId}`)?.DataTable()?.row(rowIndex)?.data?.([
                purchaseDetail.description,
                amountsStr?.quantity,
                amountsStr?.price,
                amountsStr?.taxPercentage,
                amountsStr?.subTotal,
                buttonProcessGet({
                    id: purchaseDetail?.expenseConceptId,
                    description: purchaseDetail?.description,
                    showDetails: true,
                    labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion purchase add details (datatable)

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            //#region old code
            // await sendMessageCloseCurrentWindowAsync({
            //     msgType: 0,
            //     msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
            //     closeWindow: false,
            //     urlGoTo: response?.urlGoTo,
            //     auth: auth,
            //     isLogout: false,
            //     languageId: languageObj?.id,
            //     subMethod: currentMethod,
            // });
            //#endregion old code
            //#endregion update purchase detail
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion purchase details (methods)

    //#region methods (others)
    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '' }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            await errosDefaultSetAsync({ subMethod: currentMethod });

            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setPriceError('');
            setRemarkError('');
            setQuantityError('');
            setPercentageError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.quantity?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.price?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.conceptsFind?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.conceptsFind?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={globalSettings?.labels?.concept?.[languageObj?.id]}
                        src={globalSettings?.images?.expenseConceptsLogo}
                        style={styles?.cardHeaderLogo}>
                    </img> - {globalSettings?.labels?.concept?.[languageObj?.id]} ({processType === 1 ? globalSettings?.labels?.edit?.[languageObj?.id]?.toLowerCase() : globalSettings?.labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 1 ? conceptsEditAsync({ e: e, subMethod: 'form - onSubmit', }) : e?.preventDefault()}>
                <Modal.Body>
                    <ul id='nothing'
                        className='products-list product-list-in-card pl-2 pr-2'>
                        <li className='item'>
                            <div className='product-info'>
                                <a href='#nothing'
                                    className='product-title'>{
                                        globalSettings?.labels?.purchase?.[languageObj?.id]}: {purchase?.number || 0
                                    }</a>
                                <span className='badge badge-warning float-right'>{
                                    separatorsNumbersSet({
                                        number: numberSet({
                                            number: (purchaseDetail?.quantity || neutralValue) * (purchaseDetail?.price || neutralValue),
                                            type: 'd',
                                            languageId: languageObj?.id,
                                            subMethod: 'badge - conceptAmount',
                                        })?.result,
                                        withDecimals: true,
                                        consoleLogErrorShow: true,
                                        subMethod: 'badge - conceptAmount',
                                    })?.result
                                }</span>
                                <span className='product-description'>
                                    {purchaseDetail?.description || ''}
                                </span>
                            </div>
                        </li>
                    </ul>

                    {processType === 1 ?
                        <div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input className='form-control text-right'
                                                //autoFocus
                                                onChange={(e) => setPurchaseDetail({
                                                    ...purchaseDetail,
                                                    'quantity': validateDecimals({
                                                        e: e,
                                                        languageId: languageObj?.id,
                                                        subMethod: 'input - quantity',
                                                    }),
                                                })}
                                                onFocus={() => setQuantityError('')}
                                                placeholder={globalSettings?.labels?.quantity?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.quantity?.[languageObj?.id]}
                                                value={purchaseDetail?.quantity || '0.00'} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.sortNumericUpAlt} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(quantityError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input className='form-control text-right'
                                                onChange={(e) => setPurchaseDetail({
                                                    ...purchaseDetail,
                                                    'price': validateDecimals({
                                                        e: e,
                                                        languageId: languageObj?.id,
                                                        subMethod: 'input - price',
                                                    }),
                                                })}
                                                onFocus={() => setPriceError('')}
                                                placeholder={globalSettings?.labels?.price?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.price?.[languageObj?.id]}
                                                value={purchaseDetail?.price || '0.00'} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.moneyBillWave} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(priceError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select className='form-select text-right'
                                                id={taxesId}
                                                onChange={(e) => setPurchaseDetail({ ...purchaseDetail, 'taxId': e?.target?.value, })}
                                                onFocus={() => setPercentageError('')}
                                                placeholder={globalSettings?.labels?.tax?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.tax?.[languageObj?.id]}
                                                value={purchaseDetail?.taxId || taxEmptyId}>
                                                <option key='nothing' value={taxEmptyId}>{globalSettings?.messages?.selectTax?.[languageObj?.id]}</option>
                                                {taxes?.map((tax) => <option key={tax?.id} value={tax?.id}>{
                                                    separatorsNumbersSet({
                                                        number: tax?.percentage,
                                                        withDecimals: true,
                                                        consoleLogErrorShow: true,
                                                        subMethod: 'select - taxes',
                                                    })?.result
                                                }</option>)}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-percentage' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(percentageError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <textarea className='form-control'
                                                onChange={(e) => setPurchaseDetail({ ...purchaseDetail, remark: e?.target?.value, })}
                                                onFocus={() => setRemarkError('')}
                                                placeholder={globalSettings?.labels?.remark?.[languageObj?.id]}
                                                rows={2}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.remark?.[languageObj?.id]}
                                                value={purchaseDetail?.remark || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.spellCheck} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(remarkError)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {globalSettings?.labels?.quantity?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        separatorsNumbersSet({
                                            number: purchaseDetail?.quantity || neutralValue,
                                            withDecimals: true,
                                            subMethod: 'lbl - quantity',
                                        })?.result
                                    }</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {globalSettings?.labels?.price?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        separatorsNumbersSet({
                                            number: purchaseDetail?.price || neutralValue,
                                            withDecimals: true,
                                            subMethod: 'lbl - price',
                                        })?.result
                                    }</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {globalSettings?.labels?.tax?.[languageObj?.id]} (%):
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        separatorsNumbersSet({
                                            number: purchaseDetail?.taxPercentage || neutralValue,
                                            withDecimals: true,
                                            subMethod: 'lbl - tax',
                                        })?.result
                                    }</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {globalSettings?.labels?.remark?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        HtmlParser(purchaseDetail?.remark?.replaceAll('\n', '<br/>')) || ''
                                    }</b>
                                </div>
                            </div>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer >
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={globalSettings?.labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}
                            tooltip='tooltip'
                            title={globalSettings?.labels?.close?.[languageObj?.id]}
                            type='button'>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}